"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("@ahmdigital/constants");
var _fp = require("lodash/fp");
let liveChatState = {};
const formatLiveChatData = data => {
  const getChatVisitorConversationId = (conversationId, visitorId) => !conversationId && !visitorId ? _constants.ANALYTICS.VALUES.NULL : `${visitorId || ''} | ${conversationId || ''}`;
  const formattedData = {
    chat_agent_id: data.agentId || _constants.ANALYTICS.VALUES.NULL,
    chat_status: data.agentId ? 'agent_id_available' : 'agent_id_unavailable',
    chat_visitor_conversation_id: getChatVisitorConversationId(data.conversationId, data.visitorId)
  };
  return formattedData;
};
const updateLiveChatState = (data, submitChatStateToGA4) => {
  const liveChatData = formatLiveChatData(data);
  if (!(0, _fp.isEqual)(liveChatState, liveChatData)) {
    const mapWithKey = _fp.map.convert({
      cap: false
    });
    mapWithKey((value, key) => {
      liveChatState = (0, _fp.set)(key, value, liveChatState);
    }, liveChatData);
    submitChatStateToGA4(liveChatState);
  }
};
var _default = updateLiveChatState;
exports.default = _default;